var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83325 1.16665C2.83325 0.706409 3.20635 0.333313 3.66659 0.333313C4.12682 0.333313 4.49992 0.706409 4.49992 1.16665V1.99998H9.49992V1.16665C9.49992 0.706409 9.87301 0.333313 10.3333 0.333313C10.7935 0.333313 11.1666 0.706409 11.1666 1.16665V1.99998H11.9999C12.9204 1.99998 13.6666 2.74617 13.6666 3.66665V12C13.6666 12.9205 12.9204 13.6666 11.9999 13.6666H1.99992C1.07944 13.6666 0.333252 12.9205 0.333252 12V3.66665C0.333252 2.74617 1.07944 1.99998 1.99992 1.99998H2.83325V1.16665ZM11.9999 5.33331H1.99992V12H11.9999V5.33331Z",
    fill: "#9965F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1402b4cd2d71a1f3e58aab3c88d27191.svg";
export { ForwardRef as ReactComponent };